import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/20/solid';

const SablonArama = ({ aramaMetni, setAramaMetni }) => {
  const handleInputChange = (e) => {
    setAramaMetni(e.target.value);
  };

  return (
    <div className="relative w-full max-w-3xl">
      <input
        type="text"
        placeholder="Şablon ara..."
        className="app-input pl-11"
        value={aramaMetni}
        onChange={handleInputChange}
        aria-label="Şablon ara"
      />
      <MagnifyingGlassIcon className="pointer-events-none absolute left-3.5 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" />
    </div>
  );
};

export default SablonArama;
